import React from "react";

import ExperianAuthModal from "./ExperianAuthModal";

interface ExperianAuthModalProps {
  submit: () => void;
  onCancel?: () => void;
}

const ExperianAuthModalContainer = ({
  submit,
  onCancel,
}: ExperianAuthModalProps) => {
  return (
    <ExperianAuthModal
      title="Authentication required"
      submit={submit}
      onCancel={onCancel}
    />
  );
};

export default ExperianAuthModalContainer;
